import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { CURRICULUM } from "@/lib/curriculum";
import { MOODS, SCENES, posterFor } from "@/lib/journey";

export const ContinueBanner = ({ nextId, completedCount = 0 }) => {
  const mod = CURRICULUM.find((m) => m.id === nextId);
  if (!mod) return null;
  const started = completedCount > 0;
  return (
    <Link
      to={`/modules/${nextId}/experience`}
      data-testid="continue-banner"
      className="group relative block overflow-hidden border border-[#F59E0B]/50 hover:border-[#F59E0B] transition-colors duration-500 mb-6"
    >
      <img
        src={posterFor(nextId)}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-[1.03] transition-all duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#FAF7F2] via-[#FAF7F2]/85 to-[#FAF7F2]/30" />
      <div className="relative z-10 p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="min-w-0">
          <div className="section-tag mb-2" data-testid="continue-banner-label">
            {started ? "Continue where you left off" : "Start your journey"}
          </div>
          <h3 className="font-display text-3xl md:text-4xl tracking-tight leading-none" data-testid="continue-banner-title">
            Module {mod.n} · {mod.title}
          </h3>
          <p className="text-[#78716C] text-sm mt-2">
            {completedCount} of 8 done · {MOODS[nextId]} · {SCENES[nextId]} · {mod.duration}
          </p>
        </div>
        <span className="btn-ember text-sm shrink-0 w-fit" data-testid="continue-banner-btn">
          <Play size={14} fill="currentColor" /> {started ? "Resume" : "Begin Module 01"}
        </span>
      </div>
    </Link>
  );
};
